import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { PlanningCutter } from 'src/app/classes/planningcutter.class';
import { environment } from 'src/environments/environment';
import { EntitiesListAbstractComponent } from './entities-list-abstract.component';
import { PlanningDetailDialogComponent } from './planning-detail-dialog.component';

export class EntitiesListAbstractComponentRules {
    static dateRule = (component: PlanningDetailDialogComponent) => {
        return component.planning.status_key !== environment.status.Planning.PlanningBakVanWessel;
    };

    static begintimeRule = EntitiesListAbstractComponentRules.dateRule;
    static endtimeRule = EntitiesListAbstractComponentRules.dateRule;

    static hiring_idRule = (
        component: PlanningDetailDialogComponent,
        entityHas: PlanningCutter | PlanningHasEntity
    ) => {
        return (
            entityHas.entity &&
            !entityHas.entity.use_once &&
            [environment.status.Planning.PlanningDefinitief, environment.status.Planning.PlanningBevestigd].includes(
                component.planning.status_key
            )
        );
    };
}

export function RequiredRule(
    component: EntitiesListAbstractComponent<any>,
    entityHas?: PlanningCutter | PlanningHasEntity
): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const getControlName = (c: AbstractControl): string | null => {
            if (c && c.parent) {
                const formGroup = c.parent.controls;
                return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
            }
        };

        // controlName is empty on initializing because parent has not been set yet
        const controlName = getControlName(control);
        if (controlName) {
            const rule = EntitiesListAbstractComponentRules[controlName + 'Rule'];
            if (!rule) {
                throw new Error(
                    'No rule defined for ' +
                        controlName +
                        'Rule, please define rule in entities-list-abstract-component.required-rules.ts'
                );
            }

            if (
                (control.value == null ||
                    control.value === undefined ||
                    (Array.isArray(control.value) && control.value.length < 1)) &&
                rule.call(null, component, entityHas)
            ) {
                return { required: true };
            }
            return null;
        }
        return { required: true };
    };
}
